import { z } from 'zod';

/** 勤務スケジュール詳細の表示モード。 */
const workScheduleViewSchema = z.enum(['monthly', 'weekly']).catch('monthly');
export type WorkScheduleView = z.infer<typeof workScheduleViewSchema>;

/** 月次コンテンツの表示形式（カレンダー / 表）。週次では無視される。 */
const workScheduleDisplaySchema = z.enum(['calendar', 'table']).catch('calendar');
export type WorkScheduleDisplay = z.infer<typeof workScheduleDisplaySchema>;

/** 詳細画面の検索パラメータ（表示モード + 表示形式 + 基準日）。 */
export const workScheduleSearchSchema = z.object({
  view: workScheduleViewSchema.optional(),
  /** 月次コンテンツの表示形式。未指定は calendar。 */
  display: workScheduleDisplaySchema.optional(),
  /** 基準日（"YYYY-MM-DD"）。未指定はデモ基準日（コンポーネント側で補完）。 */
  anchor: z.string().optional()
});